export default __webpack_public_path__ + "static/media/robot.f97d07b6.png";